import { useRef, useCallback } from 'react';
import { getHeightForRow, setHeightOfRow } from './useRowHeight.helpers';
function useRowHeight(listRef) {
  var rowHeights = useRef([]);
  var getRowHeight = useCallback(function (rowIndex) {
    return getHeightForRow(rowHeights.current, rowIndex);
  }, [rowHeights]);
  var setRowHeight = useCallback(function (rowIndex, rowHeight) {
    return setHeightOfRow({
      rowHeights: rowHeights.current,
      rowHeight: rowHeight,
      rowIndex: rowIndex,
      listRef: listRef
    });
  }, [rowHeights, listRef]);
  return {
    getRowHeight: getRowHeight,
    setRowHeight: setRowHeight
  };
}
export default useRowHeight;